import { call, takeEvery } from 'redux-saga/effects';
import { WorkflowConstants } from 'constants/workflowConstants';
import { request } from 'components/Fetch';

function* checkinAction(action) {
  yield call(request({
    type: WorkflowConstants.CHECKIN_ACTION,
    method: 'POST',
    url: action.payload.url,
  }), action);
}

function* nextAction(action) {
  yield call(request({
    type: WorkflowConstants.NEXT_ACTION,
    method: 'PUT',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* checkPreviousAction(action) {
  yield call(request({
    type: WorkflowConstants.PREVIOUS_ACTION,
    method: 'PUT',
    url: action.payload.url,
  }), action);
}

function* getBankDetails(action) {
  yield call(request({
    type: WorkflowConstants.GET_BANK_DETAILS,
    method: 'GET',
    url: action.payload.url,
    apiUrl: action.payload.apiUrl,
  }), action);
}

function* getIPAddress(action) {
  yield call(request({
    type: WorkflowConstants.GET_IP_ADDRESS,
    method: 'GET',
    apiUrl: 'https://api.ipify.org?format=json&callback=?',
    nullData: true,
  }), action);
}

function* getKeyAction(action) {
  yield call(request({
    type: WorkflowConstants.GET_KEY_ACTION,
    method: 'GET',
    url: `/workflows/${action.payload.workflowType}/${action.payload.entityType}/${action.payload.entityId}/workflow/key`,
    succes: action.payload.success,
  }), action);
}

function* getTestValuesData(action) {
  yield call(request({
    type: WorkflowConstants.GET_TEST_VALUES_DATA,
    method: 'GET',
    url: action.payload.url,
    succes: action.payload.success,
  }), action);
}

function* resumeApplicationSaga(action) {
  yield call(request({
    type: WorkflowConstants.RESUME_APPLICATION,
    method: 'PUT',
    url: `/workflows/${action.payload.workflowType}/${action.payload.key}/step/continuefromcreditfreeze`,
  }), action);
}

function* getAutopayDrafts(action) {
  yield call(request({
    type: WorkflowConstants.GET_AUTOPAY_DRAFTS,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

export default function* () {
  yield takeEvery(WorkflowConstants.CHECKIN_ACTION, checkinAction);
  yield takeEvery(WorkflowConstants.NEXT_ACTION, nextAction);
  yield takeEvery(WorkflowConstants.PREVIOUS_ACTION, checkPreviousAction);
  yield takeEvery(WorkflowConstants.GET_BANK_DETAILS, getBankDetails);
  yield takeEvery(WorkflowConstants.GET_IP_ADDRESS, getIPAddress);
  yield takeEvery(WorkflowConstants.GET_KEY_ACTION, getKeyAction);
  yield takeEvery(WorkflowConstants.GET_TEST_VALUES_DATA, getTestValuesData);
  yield takeEvery(WorkflowConstants.RESUME_APPLICATION, resumeApplicationSaga);
  yield takeEvery(WorkflowConstants.GET_AUTOPAY_DRAFTS, getAutopayDrafts);
}
